import { Label } from '@cian/ui-kit';
import * as React from 'react';

import { getPromoCodeExpiresIn } from './utils/getPromoCodeExpiresIn';

interface IProps {
  expirationDate: string;
  onDateExpired: () => void;
}

/**
 * Компонент для отображения времени до окончания акции
 * @param expirationDate - дата окончания акции.
 * @param onDateExpired - функция, которая вызывается, когда акция закончилась.
 */
export const PromoExpiration = ({ expirationDate, onDateExpired }: IProps) => {
  const [expiresAt, setExpiresAt] = React.useState<string>(() => getPromoCodeExpiresIn(expirationDate));

  React.useEffect(() => {
    const timerId = setInterval(() => {
      const timeLeft = getPromoCodeExpiresIn(expirationDate);

      setExpiresAt(timeLeft);
    }, 1000);

    return () => {
      clearInterval(timerId);
    };
  }, [expirationDate, onDateExpired]);

  if (!expiresAt) {
    onDateExpired();
  }

  return (
    <Label color="#152242" background="#fff">
      Осталось {expiresAt}
    </Label>
  );
};
